import { Instagram } from "lucide-react";

export function InstagramReels({ reels = [], instagramUrl }) {
  const handle = `@${(instagramUrl || "").replace(/\/$/, "").split("/").pop()}`;
  return (
    <section className="max-w-7xl mx-auto px-6 pb-24" data-testid="founder-reels">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] text-amber-400 font-adult-mono code-underline">On Instagram</div>
          <h2 className="mt-4 font-adult-heading text-3xl font-semibold tracking-tight">Reels from Sankalp.</h2>
        </div>
        <a href={instagramUrl} target="_blank" rel="noreferrer" data-testid="founder-instagram-follow"
          className="inline-flex w-fit items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:opacity-90 transition-opacity">
          <Instagram className="w-4 h-4" />Follow {handle}
        </a>
      </div>
      {reels.length === 0 ? (
        <div data-testid="founder-reels-empty" className="rounded-3xl border border-dashed border-zinc-800 p-10 text-center bg-zinc-950/50">
          <Instagram className="w-6 h-6 mx-auto text-pink-400" />
          <div className="mt-3 font-adult-heading text-xl">Reels coming soon</div>
          <p className="mt-2 text-sm text-zinc-400">Follow {handle} to catch the latest reels first.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="founder-reels-grid">
          {reels.map((r) => (
            <div key={r.code} data-testid={`reel-${r.code}`} className="rounded-2xl overflow-hidden border border-zinc-800 bg-white">
              <iframe src={r.embed_url} title={`Instagram reel ${r.code}`} loading="lazy" scrolling="no" allowFullScreen className="w-full h-[620px] border-0" />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
